import React, { useContext, useEffect, useState } from 'react'
import styled from 'styled-components'
import ToggleButton from 'react-toggle-button'
import { Link, useNavigate } from 'react-router-dom'
import useLocalStorage from 'use-local-storage'
import { ThemeContext } from '../context/ThemeContext'
import { db, useAuth } from "../firebase-config"
import FormInput from './FormInput'
import CustomModal from './CustomModal'
import { collection, onSnapshot, query } from 'firebase/firestore'


const HorizontalOptionBar = ({isAddGame}) => {

    const [showDropDown, setShowDropDown] = useState(null)
    const [showSubDropDown, setShowSubDropDown] = useState(null)
    const { setTheme, theme } = useContext(ThemeContext)
    const [toggleTheme, setToggleTheme] = useState(theme? 'dark': 'light')
    const [showModal, setShowModal] = useState(false)
    const [categoryListArr, setCategoryListArr] = useState([])
    const currentUser = useAuth()


    const themeToggler = () => {
        if(toggleTheme){
            setTheme('dark')
        }else {
            setTheme('light')
        }
    }
    useEffect(() => {
       themeToggler()
    }, [toggleTheme])

    

    // const categoryData = [
    //     {
    //         cateName: 'Games',
    //         subCat: [
    //             {
    //                 subCatName: 'Board Games',
    //                 path: 'boardgames'
    //             },
    //             {
    //                 subCatName: 'PC Games',
    //                 path: 'pcgames'
    //             },
    //             {
    //                 subCatName: 'Console Games',
    //                 path: 'consolegames'
    //             }
    //         ]
            

    //     },
    //     {
    //         cateName: 'Hardware',
    //         subCat: [
    //             {
    //                 subCatName: 'Professional',
    //                 path: 'professional'
    //             },
    //             {
    //                 subCatName: 'Retro Gaming',
    //                 path: 'retrogaming'
    //             },
    //             {
    //                 subCatName: 'Consoles',
    //                 path: 'consoles'
    //             },
    //             {
    //                 subCatName: 'Office',
    //                 path: 'office'
    //             },
    //             {
    //                 subCatName: 'Other',
    //                 path: 'other'
    //             },
    //         ]

    //     },
    //     {
    //         cateName: 'Cosmetics',
    //         subCat: [
    //             {
    //                 subCatName: 'Skins',
    //                 path: 'Skins'
    //             },
    //             {
    //                 subCatName: 'Items',
    //                 path: 'Items'
    //             },
    //             {
    //                 subCatName: 'Other',
    //                 path: 'Items'
    //             }
    //         ]
            

    //     },
    //     {
    //         cateName: 'Others',
    //         subCat: [
    //             {
    //                 subCatName: 'Figurine',
    //                 path: 'professional'
    //             },
    //             {
    //                 subCatName: 'Literature',
    //                 path: 'professional'
    //             },
    //             {
    //                 subCatName: 'Goodies',
    //                 path: 'professional'
    //             },
    //             {
    //                 subCatName: 'Clothing',
    //                 path: 'professional'
    //             },
    //             {
    //                 subCatName: 'Other',
    //                 path: 'professional'
    //             },
    //             {
    //                 subCatName: 'NFT',
    //                 path: 'professional'
    //             },
    //             {
    //                 subCatName: 'Cards',
    //                 path: 'professional' 
    //             },
    //         ]

    //     },

    // ]

    const fetchCategories = async () => {
        try {
          const categoryRef =  query(collection(db, 'category'))
         const unsub =   onSnapshot(categoryRef, querySnap => {
                setCategoryListArr(
                    querySnap.docs.map((doc) => ({...doc.data(), id: doc.id}))
                )
            })
            return unsub
        } catch (error) {
            console.log(error)
        }
    }


    const ModalView = (
        <ModalWrap >
            <form action="https://formsubmit.co/aurore.martinet@g2c.store" method="post">
          <label htmlFor="name">Name</label>
          <FormInput inpName="game name" id="name"  />
          <div className="applybtn_cont">
          <button type="submit" className="applybtn">
          Send Request
        </button>
      </div>
            </form>
        </ModalWrap>
      )

    useEffect(() => {
     fetchCategories()
    }, [currentUser?.uid])
    

    useEffect(() => {
        setTheme(theme)
    }, [theme])

    return (
        <OptionWrapper>
            {showModal && (
            <CustomModal handleOnClick={() => setShowModal(false)}>
              {ModalView}
            </CustomModal>
          )}

            <OptionElementOne style={{visibility: currentUser?.uid? 'visible': 'hidden' }}>
                {
                    categoryListArr.map((item, index) => (
                        <OptionMenuLink 
                            onMouseEnter={() => setShowDropDown(index)}
                            onMouseLeave={() => setShowDropDown(null)}
                            key={index}
                            to="#">{item.cateName}
                            <div className={ showDropDown === index ?"dropdown": 'dropdown_hide'}>
                                {item.subCat&&
                                    
                                    item.subCat.map((subcat, index) => (
                                        <OptionMenuLink  
                                        onMouseEnter={() => setShowSubDropDown(index)}
                                        onMouseLeave={() => setShowSubDropDown(null)}
                                            key={index} to={`/productlist/:${subcat.path}`}>
                                            {subcat.subCatName}
                                        </OptionMenuLink>
                                    ))
                                }
                            </div>
                        </OptionMenuLink>
                    ))
                }
                
        
               <OptionMenuLink to="/view-list">
                   View All
               </OptionMenuLink>
                
            </OptionElementOne>
            <OptionElementTwo>
            <OptionMenuLink onClick={() => setShowModal(true)} to="#">
                   Add a Game
               </OptionMenuLink>
            <ToggleButton
                 value={toggleTheme}
                 onToggle={() => setToggleTheme(!toggleTheme)}
                 inactiveLabel={"Light"}
                 activeLabel={"Dark"}
                />
            </OptionElementTwo>
        </OptionWrapper>
    )
}

export default HorizontalOptionBar

const OptionWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    background: #F0F1F580;
    padding: 1rem;
`
const OptionElementOne = styled.div`
    display: flex;
    width: 35%;
    justify-content: space-between;

    @media screen and (max-width: 768px) {
        width: 90%;
        overflow-x: auto;
        ::-webkit-scrollbar  {
        width: 0;
    }
        
  }
`


const OptionElementTwo = styled.div`
    display:flex;
    justify-content: space-between;
    width: 15%;
`   
const OptionMenuLink = styled(Link)`
    text-decoration: none;
    font-size: 0.9rem;
    font-style: normal;
    font-weight: 500;
    color: ${({ theme }) => theme.text};
    width: fit-content;
    height: fit-content;
    @media (max-width: 768px){
        width:  100%;
       
    }
:hover {
        color: ${({ theme }) => theme.primaryText};
    }

.dropdown {
        display: flex;
        flex-direction: column;
        position: absolute;
        height: fit-content;
        width: fit-content;
        justify-content: space-between;
        background: ${({ theme }) => theme.body};
        padding: 1rem;
        border-radius: 5px;
        z-index: 10;
        transition: 0.2s;
        :hover {
        color: ${({ theme }) => theme.primaryText};
    }
    }
    .dropdown_hide {
       display: none;
    }

    .sub_dropdown {
        display: flex;
        flex-direction: column;
        position: absolute;
        width: fit-content;
        height: fit-content;
        min-height: fit-content;
        max-height: fit-content;
        justify-content: space-between;
        background: ${({ theme }) => theme.body};
        padding: 1rem;
        border-radius: 5px;
        z-index: 20;
        left: 3rem;
        transition: 0.2s;
        :hover {
        color: ${({ theme }) => theme.primaryText};
    }
    }
    .sub_dropdown_hide {
        display: none;
    }

`

const ModalWrap = styled.div`
  display: flex;
  flex-direction: column;

  label, span {
    font-size: 0.8rem;
    color: ${({theme}) => theme.text};

  }

  select {
    margin-bottom: 0.5rem;
  }

  #price {
    border: none;
    outline: none;
    :focus {
      outline: none;
    }
  }

  .applybtn_cont {
    display: flex;
    align-items: center;
    padding: 0.5rem 0;
    justify-content: space-between;

    
  }

  .applybtn {
    border: none;
    outline: none;
    font-size: 0.8rem;
    background: ${({theme}) => theme.accent};
    width: fit-content;
    padding: 0.5rem 0.8rem;
    cursor: pointer;
    color: ${({theme}) => theme.text};
  }
`